import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

const ContactFormSA = ({ isCta = false }) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
  } = useForm({
    defaultValues: {
      name: '',
      phone: '',
      email: '',
      company: '',
    }
  });

  const onSubmit = (data) => {
    console.log('Standard Auditing form submit:', data);
    navigate('/thank-you');
  };

  if (isSubmitSuccessful) {
    if (isCta) {
      return (
        <div style={{
          background: 'rgba(252,253,254,0.08)',
          border: '1px solid rgba(252,253,254,0.2)',
          borderRadius: '14px',
          padding: '32px',
          color: '#FBFAF6',
          fontFamily: "'Montserrat', sans-serif",
          fontSize: '17px',
          fontWeight: 800,
          textAlign: 'center',
          width: '100%',
        }}>
          ✓ Thank you — we'll be in touch shortly.
        </div>
      );
    }

    return (
      <div style={{ padding: '40px 28px', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <div style={{ fontSize: '34px', color: '#2BAA5E' }}>✓</div>
        <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '19px', fontWeight: 800, color: '#26332C' }}>
          Thank you — we'll be in touch shortly.
        </div>
        <div style={{ fontSize: '14px', color: '#5C574C' }}>
          A consultant will contact you within one business day.
        </div>
      </div>
    );
  }

  // Wrapper Styles
  const wrapperStyle = isCta
    ? {
      width: '100%',
      background: 'rgba(252,253,254,0.06)',
      border: '1px solid rgba(252,253,254,0.15)',
      borderRadius: '16px',
      padding: '28px',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    }
     : {
      padding: '24px 28px 26px',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    };

  // Input Styles
  const getInputStyle = (hasError) => ({
    padding: '12px 14px',
    border: hasError ? '1.5px solid #EA4335' : (isCta ? '1px solid rgba(252,253,254,0.25)' : '1px solid #DCD5C5'),
    borderRadius: '8px',
    fontSize: '14px',
    fontFamily: "'Open Sans', sans-serif",
    background: isCta ? 'rgba(252,253,254,0.08)' : '#FBFAF6',
    color: isCta ? '#FBFAF6' : '#39362F',
    outline: 'none',
    transition: 'border-color 0.2s',
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={wrapperStyle} noValidate>
      <div>
        <input
          placeholder="Full Name *"
          style={{ ...getInputStyle(errors.name), width: '100%' }}
          {...register('name', { required: 'Name is required' })}
        />
        {errors.name && (
          <span style={{ fontSize: '11px', color: '#EA4335', marginTop: '2px', display: 'block', textAlign: 'left' }}>
            {errors.name.message}
          </span>
        )}
      </div>

      <div>
        <input
          type="tel"
          placeholder="Phone Number *"
          style={{ ...getInputStyle(errors.phone), width: '100%' }}
          {...register('phone', {
            required: 'Phone number is required',
            validate: (v) => v.replace(/\D/g, '').length >= 7 || 'Please enter at least 7 digits',
          })}
        />
        {errors.phone && (
          <span style={{ fontSize: '11px', color: '#EA4335', marginTop: '2px', display: 'block', textAlign: 'left' }}>
            {errors.phone.message}
          </span>
        )}
      </div>

      <div>
        <input
          type="email"
          placeholder="Email Address *"
          style={{ ...getInputStyle(errors.email), width: '100%' }}
          {...register('email', {
            required: 'Email address is required',
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
              message: 'Please enter a valid email address',
            },
          })}
        />
        {errors.email && (
          <span style={{ fontSize: '11px', color: '#EA4335', marginTop: '2px', display: 'block', textAlign: 'left' }}>
            {errors.email.message}
          </span>
        )}
      </div>

      <div>
        <input
          placeholder="Company Name"
          style={{ ...getInputStyle(false), width: '100%' }}
          {...register('company')}
        />
      </div>

      <button
        type="submit"
        style={{
          background: '#B5652E',
          color: '#FBFAF6',
          border: 'none',
          borderRadius: '8px',
          padding: '14px',
          fontSize: '15px',
          fontWeight: 800,
          fontFamily: "'Montserrat', sans-serif",
          cursor: 'pointer',
          marginTop: '4px',
          transition: 'background 0.2s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#984F24';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#B5652E';
        }}
      >
        Show Me Where I Stand →
      </button>

      {isCta ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontSize: '12px', color: '#8A8377', marginTop: '4px' }}>
          <svg viewBox="0 0 48 48" style={{ width: '14px', height: '14px' }} xmlns="http://www.w3.org/2000/svg" aria-label="Google">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
          </svg>
          <span><strong style={{ color: '#FBFAF6' }}>4.9</strong> on Google — join 500+ businesses who trust us</span>
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontSize: '12.5px', color: '#5C574C', marginTop: '4px' }}>
          <svg viewBox="0 0 48 48" style={{ width: '16px', height: '16px' }} xmlns="http://www.w3.org/2000/svg" aria-label="Google">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
          </svg>
          <span style={{ color: '#B5652E', letterSpacing: '1px' }}>★★★★★</span>
          <span><strong style={{ color: '#26332C' }}>4.9</strong> on Google · 100% confidential</span>
        </div>
      )}
    </form>
  );
};

export default ContactFormSA;
